var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subNavbar"},[_c('div',{staticClass:"flex align-center margin-auto justify-center"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"subNavbarItem",on:{"click":function($event){return _vm.handleClick(index,item)}}},[_vm._v(_vm._s(item.title))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }